import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { EmbedBridgeService } from '../services/embed-bridge.service';
import { EmbedSessionService } from '../services/embed-session.service';

/**
 * Attaches x-company-id + x-access-token for admin API calls only.
 * Match/AI requests are left untouched.
 */
export const adminAuthInterceptor: HttpInterceptorFn = (req, next) => {
  const session = inject(EmbedSessionService);
  const bridge = inject(EmbedBridgeService);

  const adminBase = session.adminBaseUrl();
  const isAdminRequest = Boolean(adminBase && req.url.startsWith(adminBase));

  let outgoing = req;
  if (isAdminRequest) {
    const companyId = session.companyId().trim();
    const token = session.token().trim();
    let headers = req.headers;
    if (companyId) {
      headers = headers.set('x-company-id', companyId);
    }
    if (token) {
      headers = headers.set('x-access-token', token);
    }
    outgoing = req.clone({ headers });
  }

  return next(outgoing).pipe(
    catchError((error: HttpErrorResponse) => {
      if (
        isAdminRequest &&
        (error.status === 401 || error.status === 403)
      ) {
        session.clearAuth();
        bridge.notifyAuthExpired(
          'Admin API returned unauthorized. Refresh host auth and call ai-cf:update-auth.'
        );
      }
      return throwError(() => error);
    })
  );
};
